/**
 * Badge — status pill for a tenant. Maps the three tenant statuses onto the
 * design system's shared {@link UiBadge} (active → done, suspended → warning,
 * deactivated → neutral). The visible label is supplied by the caller (i18n).
 */

import React from 'react';
import { Badge as UiBadge, type BadgeTone } from '@obrava/ui';
import type { TenantStatus } from '@obrava/shared';

export interface BadgeProps {
  readonly status: TenantStatus;
  readonly label: string;
}

export function Badge(props: BadgeProps): React.ReactElement {
  const tone: BadgeTone =
    props.status === 'active' ? 'done' : props.status === 'suspended' ? 'warning' : 'neutral';
  return <UiBadge tone={tone} label={props.label} />;
}
